export default __webpack_public_path__ + "static/media/cup.f46d6dd2.webp";